import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import Antibody, {AntibodyProps} from 'antibodies/visualization/Antibody';
import {FONT_PROXIMA_13, FONT_WEIGHT_PROXIMA_SEMIBOLD} from 'styles/FontConstants';

export interface AntibodyFormatPickerProps {
  antibodyProps: Array<AntibodyProps>;
  disabled: boolean;
  selectedFormat: string | null;
  setSelectedFormat: (formatId: string | null) => void;
}

export default function AntibodyFormatPicker({
  antibodyProps,
  disabled,
  selectedFormat,
  setSelectedFormat,
}: AntibodyFormatPickerProps): JSX.Element {
  return (
    <div className={css(styles.picker)}>
      {antibodyProps.map((props) => (
        <div key={props.format.id} className={css(styles.buttonWrapper)}>
          <button
            className={classNames(css(styles.button), {
              [css(styles.selectedButton)]: props.format.id === selectedFormat,
              [css(styles.disabled)]: disabled,
            })}
            onClick={() => {
              if (disabled) {
                return;
              }
              if (selectedFormat === props.format.id) {
                setSelectedFormat(null);
              } else {
                setSelectedFormat(props.format.id);
              }
            }}
            type="button"
            aria-label={`${props.format.name} format`}
          >
            <Antibody {...props} />
          </button>
          <div className={css(styles.buttonLabel)}>{props.format.name}</div>
        </div>
      ))}
    </div>
  );
}

const styles = StyleSheet.create({
  picker: {
    display: 'flex',
    gap: '16px',
  },
  buttonWrapper: {
    flex: '0 0 120px',
    display: 'flex',
    flexDirection: 'column',
  },
  buttonLabel: {
    display: 'flex',
    justifyContent: 'center',
    ...FONT_PROXIMA_13,
    fontWeight: FONT_WEIGHT_PROXIMA_SEMIBOLD,
  },
  button: {
    backgroundColor: Color.GRAY_50,
    border: `1px solid ${Color.GRAY_100}`,
    borderRadius: '4px',
    width: '120px',
    height: '120px',
    flex: '0 0 120px',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: '16px',
  },
  selectedButton: {
    borderColor: Color.BLUE_450,
  },
  disabled: {
    cursor: 'not-allowed',
  },
});
